const KontentImageFitModeEnum = {
  /** Resizes the image to fit within the width and height boundaries without cropping or distorting the image. */
  CLIP: "clip",
  /** Resizes the image to fill the width and height dimensions and crops any excess image data. */
  CROP: "crop",
  /** Scales the image to fit the constraining dimensions exactly.  */
  SCALE: "scale",
} as const

type KontentImageFitModeEnumValue = (typeof KontentImageFitModeEnum)[keyof typeof KontentImageFitModeEnum]

const FALLBACK_FORMAT = "jpg" // This is the format that will be used if WebP is not supported

/**
 * Get an optimized image url.
 *
 * Because we use 'auto=format' it will have auto quality and WebP format when supported
 */
export function getOptimizedImageSrc({
  dpr,
  fit = KontentImageFitModeEnum.CROP,
  size,
  src,
}: {
  dpr: number
  fit?: KontentImageFitModeEnumValue
  size?: { height: number; width: number }
  src: string
}): string {
  const queryParams = new URLSearchParams()

  queryParams.append("fit", fit)
  queryParams.append("fm", FALLBACK_FORMAT)
  queryParams.append("auto", "format")

  if (dpr) {
    queryParams.append("dpr", `${dpr}`)
  }

  if (size) {
    queryParams.append("w", `${size.width}`)
    queryParams.append("h", `${size.height}`)
  }

  return `${src}?${queryParams.toString()}`
}
